(function ($, document) {
    'use strict';

    $(document).ready(function () {
        const $target = $('.js-swipe-target');
        const activeClass = 'is-active';

        $target.each(function () {
            const $this = $(this);
            const $trigger = $this.parent().find('.js-swipe-trigger');

            const checkTargetOverflow = () => {
                const containerWidth = $this.parent().width();
                const contentWidth = $this[0].scrollWidth;

                if (contentWidth > containerWidth) {
                    $trigger.addClass(activeClass);
                    $trigger.attr('aria-hidden', 'false');
                } else {
                    $trigger.removeClass(activeClass);
                    $trigger.attr('aria-hidden', 'true');
                }
            }

            checkTargetOverflow();

            $(window).on('resize', checkTargetOverflow);
        });
    });

})(jQuery, document);
